import { IBaseFormProps } from "../interfaces";
import BaseForm from "./BaseForm";
import MediaForm from "./MediaForm";
import MomentForm from "./MomentForm";

interface IFormData {
  modelName: string;
  form: (props: IBaseFormProps) => JSX.Element;
}

/**
 * Form List
 * Add a form and add it to this list to be auto-selected by the create/update indices
 */
const formList: IFormData[] = [
  {
    modelName: "moment",
    form: MomentForm,
  },
  {
    modelName: "landmark",
    form: MomentForm,
  },
  {
    modelName: "media",
    form: MediaForm,
  },
];

export const getForm = (
  modelName: string
): ((props: IBaseFormProps) => JSX.Element) => {
  const form =
    formList.find((form) => form.modelName === modelName)?.form || BaseForm;
  return form;
};
